import React, { useEffect } from 'react';

const COLORS = {
    success: {
        background: 'linear-gradient(90deg, #26a899 0%, #6ee7b7 100%)',
        color: '#fff',
        icon: '✔️',
    },
    error: {
        background: 'linear-gradient(90deg, #dc3545 0%, #f87171 100%)',
        color: '#fff',
        icon: '❌',
    },
    info: {
        background: 'linear-gradient(90deg, #9c70f3 0%, #a5b4fc 100%)',
        color: '#fff',
        icon: 'ℹ️',
    },
};

const AlertPopup = ({ message, type = 'info', onClose, duration = 3500 }) => {
    useEffect(() => {
        if (!message) return;
        const timer = setTimeout(() => {
            if (onClose) onClose();
        }, duration);
        return () => clearTimeout(timer);
    }, [message, onClose, duration]);

    if (!message) return null;
    const style = COLORS[type] || COLORS.info;

    return (
        <div
            style={{
                position: 'fixed',
                top: 32,
                right: 32,
                zIndex: 2000,
                minWidth: 260,
                maxWidth: 400,
                background: style.background,
                color: style.color,
                borderRadius: 12,
                boxShadow: '0 4px 24px rgba(38,168,153,0.13)',
                padding: '1.1rem 1.5rem 1.1rem 1.2rem',
                display: 'flex',
                alignItems: 'center',
                gap: 16,
                fontSize: '1.08rem',
                fontWeight: 500,
                transition: 'all 0.2s',
            }}
        >
            <span style={{ fontSize: 22, marginRight: 8, color: type === 'success' ? '#9c70f3' : style.color }}>{style.icon}</span>
            <span style={{ flex: 1 }}>{message}</span>
            <button
                onClick={onClose}
                style={{
                    background: 'none',
                    border: 'none',
                    color: style.color,
                    fontSize: 20,
                    marginLeft: 8,
                    cursor: 'pointer',
                    fontWeight: 700,
                }}
                aria-label="Close"
            >
                ×
            </button>
        </div>
    );
};

export default AlertPopup; 